import { AnimatePresence } from "framer-motion";
import React from "react";

interface PageProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const Page: React.FC<PageProps> = ({ children, style }) => {
  return (
    <AnimatePresence>
      <div style={{ padding: 30, ...style }}>{children}</div>
    </AnimatePresence>
  );
};
